export default {
      id: "ic_heart-usage",
      viewBox: "0 0 27 24",
      url: "/" + "images/icons.3.109.2.svg#ic_heart-usage",
      toString: function () {
        return this.url;
      }
    }